// extracted by mini-css-extract-plugin
module.exports = {"container":"e_zr","poster":"e_Ar","player":"e_Br","play":"e_Cr","playBadge":"e_Dr","playIcon":"e_Er","loading":"e_Fr","spin":"e_Gr"};